import { Box, Typography } from "@mui/material";
import { useMemo } from "react";

import { useTypedSelector } from "@store/store";

const DEFAULT_TERMS_AND_CONDITIONS = {
  title: "Terms and conditions",
  category: "Terms and Conditions",
  description:
    "* Unless otherwise noted all pricing is on a per person twin share basis. All prices based on cash payment - credit card fees may apply. Cruise deposit, amendment and cancellation conditions apply. Special conditions may apply - please ask for full details at time of enquiry. All passports, vaccinations and visas are the responsibility of the travelling guest to secure prior to departure from Australia. Any pricing not in Australian Dollars will be converted on the day of payment into the relevant currency based on our daily rate of exchange. Please note that many of the prices shown on this website are not shown in real time. Whilst we endeavour to keep our pricing as up-to-date as possible, the advertised prices shown here may differ slightly from the live prices in our booking system. All pricing and offers are subject to availability at time of booking. Whilst all information is correct at the time of publication, offers are subject to change. We reserve the right to correct errors without penalty. Please submit any data errors/omissions you may notice on this site.",
};

export function TermsAndConditions() {
  const { cruise } = useTypedSelector((state) => state.search);

  const termsAndConditions = useMemo(() => {
    const descriptions = cruise?.cruise?.descriptions;

    if (!descriptions?.length) {
      return DEFAULT_TERMS_AND_CONDITIONS;
    }

    const targetDescription = descriptions.find((desc) => desc.category === "Terms and Conditions");

    return targetDescription ?? DEFAULT_TERMS_AND_CONDITIONS;
  }, [cruise?.cruise?.descriptions]);

  return (
    <Box mt={{ xs: 4, md: 8 }}>
      <Typography component="h2" variant="subtitle" color="text-primary">
        {termsAndConditions.title}
      </Typography>

      <Typography component="p" variant="footnote" color="text-dark" mt={{ xs: 2, md: 4 }}>
        {termsAndConditions.description}
      </Typography>
    </Box>
  );
}
